import React from "react";
import DashboardSideBar from "../../components/Shop/Layout/DashboardSideBar";
import AllRefundOrders from "../../components/Shop/AllRefundOrders";

const ShopAllRefunds = () => {
  return (
    <div className="min-h-screen bg-secondary-50">
      <DashboardSideBar active={8} />
      <div className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
            <AllRefundOrders />
        </div>
      </div>
    </div>
  );
};

export default ShopAllRefunds;




